import React from 'react';
import { ContentBlock, ElidedBlock, InterRegionPaddingBlock } from '@jbrowse/core/util/blockTypes';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import { ContentBlock as ContentBlockComponent, ElidedBlock as ElidedBlockComponent, InterRegionPaddingBlock as InterRegionPaddingBlockComponent } from '../../BaseLinearDisplay/components/Block';
import { makeTicks } from '../util';
var useStyles = makeStyles()(function (theme) {
  return {
    verticalGuidesZoomContainer: {
      position: 'absolute',
      height: '100%',
      width: '100%',
      zIndex: 1,
      pointerEvents: 'none'
    },
    verticalGuidesContainer: {
      position: 'absolute',
      height: '100%',
      zIndex: 1,
      pointerEvents: 'none',
      display: 'flex'
    },
    tick: {
      position: 'absolute',
      height: '100%',
      width: 1
    },
    majorTick: {
      background: theme.palette.action.disabled
    },
    minorTick: {
      background: theme.palette.divider
    }
  };
});
var RenderedVerticalGuides = observer(function (_ref) {
  var model = _ref.model;
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  return React.createElement(React.Fragment, null, model.staticBlocks.map(function (block, index) {
    if (block instanceof ContentBlock) {
      var ticks = makeTicks(block.start, block.end, model.bpPerPx);
      return React.createElement(ContentBlockComponent, {
        key: "".concat(block.key, "-").concat(index),
        block: block
      }, ticks.map(function (tick) {
        var x = (block.reversed ? block.end - tick.base : tick.base - block.start) / model.bpPerPx;
        return React.createElement("div", {
          key: tick.base,
          className: cx(classes.tick, tick.type === 'major' || tick.type === 'labeledMajor' ? classes.majorTick : classes.minorTick),
          style: {
            left: x
          }
        });
      }));
    }
    if (block instanceof ElidedBlock) {
      return React.createElement(ElidedBlockComponent, {
        key: block.key,
        width: block.widthPx
      });
    }
    if (block instanceof InterRegionPaddingBlock) {
      return React.createElement(InterRegionPaddingBlockComponent, {
        key: block.key,
        width: block.widthPx,
        boundary: block.variant === 'boundary'
      });
    }
    return null;
  }));
});
function VerticalGuides(_ref2) {
  var model = _ref2.model;
  var _useStyles2 = useStyles(),
    classes = _useStyles2.classes; // find the block that needs pinning to the left side for context
  var offsetLeft = model.staticBlocks.offsetPx - model.offsetPx;
  return React.createElement("div", {
    className: classes.verticalGuidesZoomContainer,
    style: {
      transform: model.scaleFactor !== 1 ? "scaleX(".concat(model.scaleFactor, ")") : undefined
    }
  }, React.createElement("div", {
    className: classes.verticalGuidesContainer,
    style: {
      left: offsetLeft,
      width: model.staticBlocks.totalWidthPx
    }
  }, React.createElement(RenderedVerticalGuides, {
    model: model
  })));
}
export default observer(VerticalGuides);